import { AxiosError } from "axios";

import { useMutation, useQuery, UseQueryOptions } from "@tanstack/react-query";

import { anexarArquivoAtendimento, anexarArquivoIntranet, cadastrarAtendimento, fetchHistoricoAtendimentos, fetchRespostaCanalDireto } from ".";
import { DefaultApiError } from "../types";
import { HistoricoAtendimento } from "../../types/atendimentos/historico/types";
import { AttachExtranetFilesParams, AttachIntranetFilesParams, TicketCreatedResponse, TicketSupportForm } from "../../types/atendimentos/pre-atendimento/types";
import { RespostaCanalDireto } from "../../types/atendimentos/channel-direct/types";

export const useFetchHistoricoAtendimentos = (
  numFicha: number,
  situacaoFicha: string,
  options?: Partial<UseQueryOptions<HistoricoAtendimento[], AxiosError<DefaultApiError>>>
) => useQuery<HistoricoAtendimento[], AxiosError<DefaultApiError>>({
  queryKey: ['historicoAtendimentos', numFicha, situacaoFicha],
  queryFn: () => fetchHistoricoAtendimentos(numFicha, situacaoFicha),
  ...options,
});



export const useCadastrarAtendimento = () =>
  useMutation<TicketCreatedResponse, AxiosError<DefaultApiError>, TicketSupportForm>({
    mutationFn: cadastrarAtendimento,
  })

export const useAnexarArquivoAtendimento = () =>
  useMutation<void, AxiosError<DefaultApiError>, AttachExtranetFilesParams>({
    mutationFn: anexarArquivoAtendimento,
  })

export const useAnexarArquivoIntranet = () =>
  useMutation<void, AxiosError<DefaultApiError>, AttachIntranetFilesParams>({
    mutationFn: anexarArquivoIntranet,
  })


export const useFetchRespostaCanalDireto = (
  numFicha: number,
  options?: Partial<UseQueryOptions<RespostaCanalDireto, AxiosError<DefaultApiError>>>
) => useQuery<RespostaCanalDireto, AxiosError<DefaultApiError>>({
  queryKey: ['buscarrespostacanaldireto', numFicha],
  queryFn: () => fetchRespostaCanalDireto(numFicha),
  ...options,
});




